import { Action, createReducer, on } from "@ngrx/store";
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

export interface State {
   catchLoginEve: boolean;
   catchInstantLoginEve: boolean;
}
export const initialState: State = {
   catchLoginEve: true,
   catchInstantLoginEve: true,
}

const analyticsReducer = createReducer(
   initialState,
   on(AnalyticsActions.eventLogin, (state) => ({ ...state, catchLoginEve: false })),
   on(AnalyticsActions.eventNewAction, (state) => ({ ...state, catchInstantLoginEve: false })),
);

export const reducer = (state: State | undefined, action: Action): State => analyticsReducer(state, action);